import { css, createGlobalStyle } from 'styled-components'
import { between } from 'polished'

export const typography = css`
  ${({ theme }) => css`
    html {
      font-family: ${theme.fonts.normal};
    }
    body {
      font-family: ${theme.fonts.normal};
      color: ${theme.colors.navy};
      font-size: ${between(
        '14px',
        '16px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '20px',
        '26px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      font-weight: 400;
      letter-spacing: 0.4px;
    }

    h1 {
      font-family: ${theme.fonts.normal};
      font-size: ${between(
        '28px',
        '36px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '32px',
        '38px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      text-transform: uppercase;
      font-weight: bold;
      letter-spacing: 2px;
    }

    h2 {
      font-family: ${theme.fonts.normal};
      font-size: ${between(
        '24px',
        '32px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '30px',
        '38px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      font-weight: 500;
    }

    h3 {
      font-family: ${theme.fonts.normal};
      font-size: ${between(
        '20px',
        '28px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '26px',
        '34px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    h4 {
      font-family: ${theme.fonts.normal};
      font-size: ${between(
        '16px',
        '20px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '22px',
        '28px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 1.7px;
    }

    h5 {
      font-family: ${theme.fonts.normal};
      font-size: ${between(
        '12px',
        '16px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      line-height: ${between(
        '18px',
        '22px',
        theme.maxWidths.small,
        theme.maxWidths.xLarge
      )};
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 1.5px;
    }
    p {
      font-family: ${theme.fonts.normal};
    }
  `}
`

export const Typography = createGlobalStyle`${typography}`
